import { Form, FormItemProps } from 'antd';
import MaskedInput from 'react-text-mask';
import { Rule } from 'antd/lib/form';
import { ChangeEvent, useCallback } from 'react';
import { NamePath } from 'antd/lib/form/interface';
import removeMask from '@/utils/mask/removeMask';
import { phoneMask, cellphoneMask } from '@/utils/mask/commonMasks';
import { maskFieldValidator } from '@/utils/mask';
import FloatingFormItem from '../FloatingFormItem';
import { phoneWithoutDDDMask } from '@/utils/mask/commonMasks/phoneMask';
import { cellphoneWithoutDDDMask } from '@/utils/mask/commonMasks/cellphoneMask';

type Props = FormItemProps & {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  fieldName?: NamePath;
  requiredRuleText?: string;
  lengthRuleText?: string;
  floating?: boolean;
  parentFieldName?: string;
  removeDDD?: boolean;
  disabled?: boolean;
  asPhone?: boolean;
  placeholder?: string;
  value?: string;
};

const PhoneFormField = ({
  onChange,
  initialValue,
  labelCol,
  wrapperCol,
  parentFieldName,
  fieldName = 'phone',
  label = 'Celular',
  requiredRuleText = 'O número do celular é obrigatório.',
  lengthRuleText = 'O número do celular não é válido',
  required = true,
  floating = true,
  removeDDD,
  disabled,
  asPhone,
  placeholder,
  value,
  rules: propRules = [],
  ...restProps
}: Props) => {
  const rules: Rule[] = [
    ...propRules,
    {
      min: removeDDD ? 8 : 10,
      max: removeDDD ? 9 : 11,
      validator: maskFieldValidator,
      message: lengthRuleText,
    },
  ];

  if (required) {
    rules.push({
      required: true,
      message: requiredRuleText,
    });
  }

  const getMask = useCallback(
    (rawValue: string) => {
      if (removeDDD) {
        if (removeMask(rawValue).length <= 8) return phoneWithoutDDDMask;

        return cellphoneWithoutDDDMask;
      } else {
        if (asPhone || removeMask(rawValue).length <= 10) return phoneMask;
        return cellphoneMask;
      }
    },
    [removeDDD, asPhone],
  );

  return floating ? (
    <FloatingFormItem
      label={label}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      name={fieldName}
      initialValue={initialValue}
      rules={rules}
      parentFieldName={parentFieldName}
      {...restProps}
    >
      <MaskedInput
        className="ant-input"
        mask={getMask}
        onChange={onChange}
        disabled={disabled}
        key={Number(asPhone)}
      />
    </FloatingFormItem>
  ) : (
    <Form.Item
      label={label}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      name={fieldName}
      initialValue={initialValue}
      rules={rules}
      noStyle={restProps.noStyle}
    >
      <MaskedInput
        value={value}
        defaultValue={initialValue}
        className="ant-input"
        mask={getMask}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        key={Number(asPhone)}
      />
    </Form.Item>
  );
};

export default PhoneFormField;
